import { createConsola, LogLevels, type LogType } from 'consola/browser'
import { useRuntimeConfig } from '#app'

export const useLogger = (tag?: string) => {
  const config = useRuntimeConfig()
  const consola = createConsola({
    level: LogLevels[(config.public.logLevel ?? 'info') as keyof typeof LogLevels],
  })
  const getSerializableContext = (context: any | undefined | null) => {
    try {
      JSON.stringify(context)
      return context
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    catch (ignore) {
      if (context?.message)
        return { message: context.message, stack: context.stack }
      return context?.toString()
    }
  }
  const createLog = (type: LogType, tag?: string) => {
    return (message: string, ...context: any[]) => {
      if (LogLevels[type] <= consola.level) {
        if (import.meta.client)
          consola[type]({
            tag,
            message,
            args: context ? [...context] : [],
            badge: true,
          })
        $fetch('/api/log', {
          method: 'POST',
          body: { type, tag, message, args: [...context.map(getSerializableContext)], ssr: import.meta.server },
        })
      }
    }
  }

  return {
    error: createLog('error', tag),
    warn: createLog('warn', tag),
    log: createLog('log', tag),
    info: createLog('info', tag),
    debug: createLog('debug', tag),
    trace: createLog('trace', tag),
  }
}
